import React from 'react';
import PropTypes from 'prop-types';
import { Card, Title, Sub, PartnerBtn, NextBtn } from '../survey.css';
import { Consumer } from 'store/createContext';
import PartnerObj from '../../../constants/partners';

const Partners = ({ goFwd, submitCampaign }) => {
  function submit() {
    submitCampaign();
    goFwd();
  }

  return (
    <Consumer>
      {({ partners, togglePartner }) => (
        <Card style={{ paddingBottom: '15px' }}>
          <Title>Your Local Partners</Title>
          <Sub>Choose your local Partners</Sub>

          {partners
            ? Object.keys(partners).map((partner, i) => (
                <PartnerBtn
                  key={i}
                  onClick={() => togglePartner(partner)}
                  selected={partners[partner].selected}
                >
                  <img src={PartnerObj[partner].logo} alt={partner} />
                  <p>{PartnerObj[partner].description}</p>
                </PartnerBtn>
              ))
            : null}

          <NextBtn
            to="survey"
            spy={true}
            smooth={true}
            offset={0}
            duration={500}
            isDynamic={true}
            href="#"
            onClick={submit}
          >
            Next
          </NextBtn>
        </Card>
      )}
    </Consumer>
  );
};

Partners.propTypes = {
  goFwd: PropTypes.func.isRequired,
  submitCampaign: PropTypes.func.isRequired,
};

export default Partners;
